import { resolveLang } from 'common/handleLocale';
import { PhotoContestSetVisible } from 'modules/API';
import Cookies from 'modules/Cookies';

$(document).on('click', '.doPhotoContestToggle', (e) => {
  e.stopPropagation();
  const elm = e.currentTarget;
  togglePhotoContestImage(
    $(elm).data('id'),
    $(elm).data('imageid'),
    !$(elm).hasClass('disabled')
  );
});

/**
 * @param {string} dialy_id
 * @param {string} image_id
 * @param {boolean} setVisible
 */
const togglePhotoContestImage = (
  dialy_id,
  image_id,
  setVisible,
  skipAPICall = false
) => {
  if (!window.Gdata.CurrentMap.ori[0].photo_contest_enabled) {
    alert(
      resolveLang(
        '表示するにはマップ設定で「フォトコンテスト」を ON にしてください。'
      )
    );
    return;
  }

  const dialy = window.Gdata.CurrentDialies.dic[dialy_id];
  if (!dialy) {
    return;
  }

  if (!skipAPICall) {
    PhotoContestSetVisible({
      session: String(Cookies.get(CookieSession)),
      dialy_id,
      image_id,
      is_visible: setVisible,
    }).catch(() => {
      alert(resolveLang('予期せぬエラーが発生しました'));
      togglePhotoContestImage(dialy_id, image_id, !setVisible, true);
    });
  }

  dialy.photo_contest_published_images =
    dialy.photo_contest_published_images || [];
  if (setVisible) {
    if (!dialy.photo_contest_published_images.includes(image_id)) {
      dialy.photo_contest_published_images.push(image_id);
    }
  } else if (dialy.photo_contest_published_images.indexOf(image_id) >= 0) {
    dialy.photo_contest_published_images.splice(
      dialy.photo_contest_published_images.indexOf(image_id),
      1
    );
  }

  dialy.is_photo_contest = !!dialy.photo_contest_published_images.length;

  if (dialy.is_photo_contest) {
    $(`.photoContestShow${dialy._id}`).removeClass('hidden');
    $(`.photoContestHide${dialy._id}`).addClass('hidden');
  } else {
    $(`.photoContestShow${dialy._id}`).addClass('hidden');
    $(`.photoContestHide${dialy._id}`).removeClass('hidden');
  }

  $('.doPhotoContestToggle').each((_, elm) => {
    if ($(elm).data('id') === dialy_id && $(elm).data('imageid') === image_id) {
      if (setVisible) {
        $(elm).addClass('disabled');
        $(elm).children('span').text(resolveLang('表示'));
      } else {
        $(elm).removeClass('disabled');
        $(elm).children('span').text(resolveLang('非表示'));
      }
    }
  });

  $('.photoCardImage').each((_, elm) => {
    if (
      $(elm).data('dialyid') === dialy_id &&
      $(elm).data('imageid') === image_id
    ) {
      if (setVisible) {
        $(elm).removeClass('photoContestHidden');
      } else {
        $(elm).addClass('photoContestHidden');
      }
    }
  });
};
